<template>
  <v-dialog
    v-model="getModalCadastroTransferenciaEstoque"
    persistent
    fullscreen
    transition="dialog-transition"
  >
    <v-card outlined :loading="$store.getters.getOverlay">
      <Alert />
      <v-card-title>Transferência entre Estoques</v-card-title>
      <v-form ref="form" class="px-3">
        <v-card-text>
          <v-layout row wrap>
            <v-flex class="pa-2" xs12>
              <h3>Pesquisar Produto (F2)</h3>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                dense
                outlined
                v-model="codigo_barras"
                id="codigo_barra"
                label="Código de Barras"
                type="number"
                class="ml-1 mr-1"
                @keyup.enter="pesquisarPorCodigoDeBarras"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md9>
              <v-text-field
                dense
                v-model="getProduto.descricao"
                label="Produto"
                outlined
                class="ml-1 mr-1"
              >
              </v-text-field>
              <template v-slot:selection="data"
                >{{ data.item.descricao }} - {{ data.item.marca }}</template
              >
              <template v-slot:item="data"
                >{{ data.item.id }} - {{ data.item.descricao }} -
                {{ data.item.marca }}</template
              >
            </v-flex>
            <v-flex xs12 md1>
              <v-text-field
                dense
                outlined
                v-model="getProduto.quantidade"
                label="Quantidade"
                id="quantidade"
                class="ml-1 mr-1"
                v-mask="[
                  '#,##',
                  '##,##',
                  '###,###',
                  '#.###,##',
                  '##.###,##',
                  '###.###,##',
                ]"
                append-outer-icon="control_point"
                @click:append-outer="
                  adicionarItemTransferenciaEstoque({
                    getItensTransferenciaEstoque,
                    getProduto,
                  })
                "
                @keyup.enter="
                  adicionarItemTransferenciaEstoque({
                    getItensTransferenciaEstoque,
                    getProduto,
                  })
                "
              ></v-text-field>
            </v-flex>
            <v-divider></v-divider>
            <v-flex class="pa-2" xs12>
              <h3>Produtos na transferência</h3>
            </v-flex>
            <v-flex xs12 class="mb-5">
              <hr />
              <v-simple-table dense fixed-header height="250px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Quantidade</th>
                      <th class="text-left">Descrição</th>
                      <th class="text-left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="p in getItensTransferenciaEstoque" :key="p.id">
                      <td>
                        {{ $helper.formatReal(parseFloat(p.quantidade)) }}
                      </td>
                      <td>{{ p.descricao }}</td>
                      <td>
                        <v-btn
                          x-small
                          color="error"
                          @click="
                            removerItemTransferenciaEstoque({
                              getItensTransferenciaEstoque,
                              getProduto: p,
                            })
                          "
                          outlined
                        >
                          <v-icon>delete_forever</v-icon>
                        </v-btn>
                        <v-btn
                          x-small
                          color="primary"
                          class="ml-2"
                          @click="visualizarProduto(p.id)"
                          v-if="$helper.verificaPermissao('visualizar-produto')"
                          outlined
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <hr />
            </v-flex>
            <v-divider></v-divider>
            <v-flex xs12 md6>
              <v-text-field
                dense
                outlined
                type="date"
                class="mr-2 ml-2"
                label="Data"
                v-model="getTransferenciaEstoque.data"
                :rules="rules.data"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                dense
                outlined
                type="time"
                class="mr-2 ml-2"
                label="Hora"
                v-model="getTransferenciaEstoque.hora"
                :rules="rules.hora"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-select
                outlined
                dense
                class="mr-2 ml-2"
                :items="getEstoques"
                item-text="nome"
                item-value="id"
                label="Estoque de origem"
                v-model="getTransferenciaEstoque.estoque_origem_id"
                :rules="rules.estoque_origem_id"
              ></v-select>
            </v-flex>
            <v-flex xs12 md6>
              <v-select
                outlined
                dense
                class="mr-2 ml-2"
                :items="getEstoques"
                item-text="nome"
                item-value="id"
                label="Estoque de destino"
                v-model="getTransferenciaEstoque.estoque_destino_id"
                :rules="rules.estoque_destino_id"
              ></v-select>
            </v-flex>

            <v-flex xs12 md12>
              <v-textarea
                dense
                outlined
                label="Observações"
                v-model="getTransferenciaEstoque.observacao"
                class="ml-2 mr-2"
                :rules="rules.observacao"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="default"
            outlined
            @click="
              $store.dispatch('ativaModalConfirmacao', {
                mensagem:
                  'Você perderá os dados que já preencheu caso não tenha salvo, deseja realmente voltar?',
                action: 'setModalCadastroTransferenciaEstoque',
                action_value: false,
              })
            "
            >Voltar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            outlined
            @click="transferir"
            :loading="$store.getters.getOverlay"
            >Transferir</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
    <ModalVisualizar v-if="getTransferenciaEstoque.id" />
    <ModalPesquisarProduto @focusInputQuantidade="focusQuantidade" />
    <ModalCadastroProduto />
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ModalVisualizar from "@/pages/estoque/transferencia/ModalVisualizar";
import ModalPesquisarProduto from "@/pages/produto/ModalPesquisarProduto";
import ModalCadastroProduto from "@/pages/produto/ModalCadastro";
import ProdutoService from "@/services/ProdutoService";

var _ = require("lodash");

export default {
  components: {
    ModalVisualizar,
    ModalPesquisarProduto,
    ModalCadastroProduto,
  },
  data() {
    return {
      codigo_barras: "",
      rules: {
        data: [(v) => !!v || "Campo obrigatório."],
        hora: [(v) => !!v || "Campo obrigatório."],
        quantidade: [(v) => !!v || "Campo obrigatório."],
        estoque_origem_id: [(v) => !!v || "Campo obrigatório."],
        estoque_destino_id: [(v) => !!v || "Campo obrigatório."],
        observacao: [(v) => !!v || "Campo obrigatório."],
      },
    };
  },
  watch: {
    codigo_barras: function () {
      if (this.codigo_barras != "") {
        this.debouncedPesquisarPorCodigoDeBarras();
      }
    },
  },
  computed: {
    ...mapGetters([
      "getModalCadastroTransferenciaEstoque",
      "getProduto",
      "getEstoques",
      "getItensTransferenciaEstoque",
      "getTransferenciaEstoque",
    ]),
  },
  methods: {
    ...mapActions([
      "listarEstoque",
      "salvarTransferenciaEstoque",
      "setModalCadastroTransferenciaEstoque",
      "setModalPesquisarProdutosOrcamento",
      "adicionarItemTransferenciaEstoque",
      "removerItemTransferenciaEstoque",
      "visualizarProduto",
    ]),
    pesquisarPorCodigoDeBarras() {
      if (this.codigo_barras == "") {
        document.getElementById("codigo_cliente").focus();
        return;
      }

      ProdutoService.porCodigoDeBarras(this.codigo_barras)
        .then((res) => {
          if (res.data.id) {
            let produto = res.data;
            this.$store.commit("setProduto", { ...produto, quantidade: 1 });
          } else {
            this.$store.commit("snackbarError", "Produto não encontado.");
            this.codigo_barras = "";
            document.getElementById("codigo_barra").focus();
          }
        })
        .catch((e) => {
          this.codigo_barras = "";
          document.getElementById("codigo_barra").focus();
          this.$store.commit("snackbarError", "Erro ao pesuisar produto.");
          console.log(e);
        });
    },
    transferir() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("ativaModalConfirmacao", {
          mensagem: "Você está prester a transferir os produtos, confirma?",
          action: "salvarTransferenciaEstoque",
          action_value: {
            ...this.getTransferenciaEstoque,
            produtos: this.getItensTransferenciaEstoque,
          },
        });
      }
    },
    focusQuantidade() {
      setTimeout(() => {
        document.getElementById("quantidade").focus();
      }, 300);
    },
    keyUp(e) {
      if (!e) e = window.event;
      let keyCode = e.keyCode || e.which;
      if (keyCode == 113) e.preventDefault();
      if (keyCode == 114) e.preventDefault();

      if (keyCode == 113) {
        this.setModalPesquisarProdutosOrcamento(true);
      }
    },
  },
  created() {
    this.listarEstoque();
    this.debouncedPesquisarPorCodigoDeBarras = _.debounce(
      this.pesquisarPorCodigoDeBarras,
      300
    );
    document.addEventListener("keydown", this.keyUp);
  },
};
</script>